import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import { ceilValue } from "vamos/cockpit/util/NumberUtil";
import Text from "sap/m/Text";
import HBox from "sap/m/HBox";
import { FlexAlignItems, FlexRendertype } from "sap/m/library";
import uid from "sap/base/util/uid";

/**
 * @namespace vamos.cockpit.base.customcontrol
 */
export default class FormattedUnit extends Control {

    private textNbg: Text;
    private textAmount: Text;
    private textBaseUnit: Text;

    static readonly metadata: MetadataOptions = {
        properties: {
            amount: { type: "string", defaultValue: "" },
            unit: { type: "string", defaultValue: "" },
            isStockManaged: { type: "boolean", defaultValue: false},
            width: { type: "string", defaultValue: "100%" },
            wrapping: { type: "boolean", defaultValue: true },
        },
        aggregations: {
            _container: { type: "sap.m.HBox", multiple: false, visibility: "hidden" }
        },
    };

    static renderer = {
        apiVersion: 4,
        render: (rm: RenderManager, control: FormattedUnit) => {
            rm.renderControl(control.getAggregation("_container") as Control);
        },
    };

    init(): void {

        this.textNbg = new Text(uid(), { text: "NBG", textAlign: "Center", width: "100%"  });
        this.textNbg.setVisible(false);
        this.textAmount = new Text(uid(), { textAlign: "End", wrapping: false});
        this.textAmount.addStyleClass("unitAmount");
        this.textBaseUnit = new Text(uid(), {wrapping: false});
        this.textBaseUnit.addStyleClass("unitDescription");


        const container = new HBox(uid(), {
            width: "100%",
            renderType: FlexRendertype.Bare,
            fitContainer: true,
            alignItems: FlexAlignItems.Center,
            items: [
                this.textNbg,
                this.textAmount,
                this.textBaseUnit,
            ],
        });

        this.setAggregation("_container", container);

    }

    setAmount(amount: string): this {
        this.setProperty("amount", amount, true);
        const amountString = ceilValue(amount);
        this.textAmount.setText(amountString);
        return this;
    }

    setUnit(unit: string): this {
        this.setProperty("unit", unit, true);
        this.textBaseUnit.setText(unit);
        return this;
    }

    setWidth(width: string): this {
        this.setProperty("width", width, true);
        const container = this.getAggregation("_container") as Control;
        container.setProperty("width", width);
        return this;
    }

    setWrapping(wrapping: boolean): this {
        this.setProperty("wrapping", wrapping, true);
        return this;
    }

    setIsStockManaged(isStockManaged: boolean): this {
            this.textBaseUnit.setVisible(!!isStockManaged);
            this.textAmount.setVisible(!!isStockManaged);
            this.textNbg.setVisible(!isStockManaged);
        this.setProperty("isStockManaged", isStockManaged, false);



        return this;
    }

}
